import styled from 'styled-components';

const StyledGalleryProds = styled.div`
  padding-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
  padding-right: 64px;
  padding-left: 64px;
  
  .gallery--wrap{
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .gallery--col-big{
    position: relative;
    flex: 0 0 50%;
  }
  .gallery--col-double{
    position: relative;
    flex: 0 0 41.65%;
  }
  .gallery-img-wrap{
    position: relative;
    width: 100%;
  }
  .mobile-tap{
    display: none;
  }
  .gallery--col img {
    display: block;
    width: 100%;
  }
  .gallery--col-double img:nth-child(1){
    margin-bottom: ${ props => props.theme.components_spacing_desk.xlarge}px;
  }
  .overlay--zoom{
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0; 
    left: 0;
    z-index: 10;
    background-color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0; 
    visibility: hidden;
    display: none;
  }
  .overlay--zoom .close--overlay{
    position: absolute;
    right: 64px;
    top: 40px;
    z-index: 11;
    width: 44px;
    height: 44px;
    cursor: pointer;
  }
  .video--holder{
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    
  }
  .video--holder video {
    display: block;
    width: 100%;
  }
  .overlay--zoom .close--overlay img {
    display: block;
    width: 100%;
  }
  .gallery--col-double .gallery-img-wrap:nth-child(1){
    margin-bottom: ${ props => props.theme.components_spacing_tablet.xlarge}px;
  }
  @media screen and (max-width: 1439px){
    padding-right: 40px;
    padding-left: 40px
  }
  @media screen and (max-width: 1024px){
    .mobile-tap{
      position: relative;
      display: block;
      pointer-events: none;
      margin-bottom: 16px;
    }
  }
  @media screen and (max-width: 1023px){
    padding-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    .gallery--col-double .gallery-img-wrap:nth-child(1){
      margin-bottom: ${ props => props.theme.components_spacing_tablet.xlarge}px;
    }
  }
  @media screen and (max-width: 767px){
    padding-right: 24px;
    padding-left: 24px;
    padding-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    .gallery--wrap{
      flex-direction: column;
    }
    .gallery--col-big,.gallery--col-double{
      flex: 0 0 100%;
    }
    .gallery--col-big,
    .gallery--col-double .gallery-img-wrap:nth-child(1){
      margin-bottom: ${ props => props.theme.components_spacing_mobile.xlarge}px;;
    }
    .overlay--zoom .close--overlay{
      right: 24px;
    }
  }
`;

export {
  StyledGalleryProds,
};

